import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
    padding: "20px 20px 0 20px",
    // color: "#002F49",

    "& h1": {
      color: '#002F49',
      fontWeight: "bolder",
      letterSpacing: "0.5px",
      marginBottom: "10px",
    },
    "& a": {
      display: "flex",
      justifyContent: "center",
    },
    "& img": {
      width: "70%",
    },
    "& .MuiAlert-root": {
      padding: "6px",
    },
  },
  alert: {
    width: "100%",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "fit-content",
    marginTop: "8px",
    "& h2": {
      color: "#002F49",
    }
  },
  loginButton: {
    height: "40px",
    backgroundColor: "#002F49",
    color: "#fff",
    borderRadius: "6px",
    marginTop: "15px",
  },
  checkbox: {
    "& svg": {
      width: "1.8rem",
      height: "1.8rem",
    },
    "& span": {
      color: "#002F49"
    },
  },
  textField: {
    marginTop: "15px",
  },
  forgotpasssword: {
    fontSize: "1rem",
    fontWeight: 'lighter',
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    color: "#002F49",
    cursor: "pointer",
  },
  signUpBox: {
    color: "#002F49",
    cursor: "pointer",
    letterSpacing: "0.8px",
    fontWeight: "400",
    padding: "18px 0",
    textAlign: "center",
    borderTop: "1px solid #F7C601",
    borderBottom: "1px solid #F7C601",
    margin: "auto",

    "& a": {
      fontWeight: "500",
    }
  }
}));

export default useStyles;
